import { render } from "./MailingBlockTitleEditor.vue?vue&type=template&id=ede12898"
import script from "./MailingBlockTitleEditor.vue?vue&type=script&lang=js"
export * from "./MailingBlockTitleEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__